// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__y-wOX","navContainer":"Navbar_navContainer__gJYF9","brand":"Navbar_brand__wAuKA","icon":"Navbar_icon__hGvZT","menu_container":"Navbar_menu_container__3VhXP"};